export class Language {
    public constructor(init?: Language) {
        Object.assign(this, init);
    }
    code: string
    name: string
    isOfficial: boolean
}
